export const ACCORDION_VERTICAL = 'dynamic-zone.accordion-vertical',
ADMISION_BUTTON = 'admision-button',
BANNER = 'general-content.carrousel',
// BANNER = 'ComponentGeneralContentCarrousel',
BANNER_BUTTONS = 'general-content.banner-buttons',
BANNER_CAROUSEL = 'orgs-units.banner-carousel',
BANNER_LIST = 'dynamic-zone.banner-list',
BANNER_VIDEO = 'general-content.banner-video',
BUILDING_LOCATION = 'institution.buildings-location',
BUTTON = 'general-content.dynamic-button',
CARDS_CAROUSEL = 'dynamic-zone.cards-carousel',
CARDS_LIST = 'general-content.cards-list',
DIAGONAL_BANNER = 'dynamic-zone.diagonal-banner',
FORM_CONNECT = 'form.form-connect',
DIARIES_LIST = 'relation-components.diaries-list',
DIARIES_LIST_ALL = 'relation-components.diaries-list-auto',
FRAME_SECTION = 'dynamic-zone.frames-section',
HERO = 'dynamic-zone.hero',
ICONS_CAROUSEL = 'dynamic-zone.icons-carousel',
ICONS_TEXT = 'dynamic-zone.icon-text-block',
INFO_CARDS = 'orgs-units.info-cards',
LOGOS_SECTION = 'dynamic-zone.logos-section',
MAPS = 'dynamic-zone.maps',
NOTES_LIST = 'relation-components.notes-list',
NOVELTIES_LIST = 'relation-components.novelties-list',
NOVELTIES_CAROUSEL = 'relation-components.novelties-carousel',
P_CAREER_FEED = 'orgs-units.feed-posgrado',
PDF = 'pages-component.pdf',
PROFESSIONALS = 'pages-component.profesional-list',
QUOTE = 'dynamic-zone.quote',
SINGLE_IMAGE = 'pages-component.header-image',
SOCIAL_MEDIAS = 'institution.social-medias',
TABS = 'pages-component.tab',
TEXT_COLUMN = 'general-content.text-column',
TEXT_CONTENT = 'orgs-units.text',
TEXT_CONTENT_PAGES = 'pages-component.text',
TEXT_IMAGE = 'pages-component.image-and-text',
TRANSITION = 'dynamic-zone.transition',
VIDEO = 'pages-component.video',
VIDEO_BACKGROUND = 'general-content.video-background'

// AUDIO_LIST = 'pages-component.audio-list',
// CALENDAR = 'pages-component.calendar',
// CONTACT_FORM = 'dynamic-zone.contact-form',
// EVENTUALITIES_LIST = 'pages-component.eventualities-list',
// GENERAL_FORM = 'general-content.form',